import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import { Link } from "react-router-dom";

import bg from "../assets/images/bg1.png";
import play from "../assets/images/play.png";
import phone from "../assets/images/app/app.png";

import FeaturesOne from "../components/features-one";
import AboutOne from "../components/about-one";
import AboutTwo from "../components/about-two";
import Screenshot from "../components/screenshot";
import Faq from "../components/faq";
import Download from "../components/download";
import Contact from "../components/contact";
import Footer from "../components/footer";

export default function IndexOne() {
  useEffect(() => {
    const scrollToFaq = () => {
      const hash = window.location.hash;
      if (hash !== "#faq" && hash !== "#faqs") return;

      const faqSection = document.getElementById("faqs");
      if (!faqSection) return;

      const navbar = document.getElementById("navbar");
      const navbarHeight = navbar?.offsetHeight || 0;
      const top =
        faqSection.getBoundingClientRect().top +
        window.scrollY -
        navbarHeight -
        8;

      window.scrollTo({ top, behavior: "smooth" });

      if (hash === "#faq") {
        window.history.replaceState(null, "", "#faqs");
      }
    };

    const initialFrameId = window.requestAnimationFrame(scrollToFaq);
    const initialTimeoutId = window.setTimeout(scrollToFaq, 350);

    window.addEventListener("hashchange", scrollToFaq);
    window.addEventListener("load", scrollToFaq);
    window.addEventListener("pageshow", scrollToFaq);

    return () => {
      window.cancelAnimationFrame(initialFrameId);
      window.clearTimeout(initialTimeoutId);
      window.removeEventListener("hashchange", scrollToFaq);
      window.removeEventListener("load", scrollToFaq);
      window.removeEventListener("pageshow", scrollToFaq);
    };
  }, []);

  return (
    <>
      <Navbar
        navLight={false}
        playBtn={false}
        bgLight={false}
        navCenter={false}
      />

      <section
        className="relative overflow-hidden md:py-36 py-24 bg-slate-50/50 dark:bg-slate-800/20 bg-no-repeat bg-center bg-cover"
        id="home"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="container relative">
          <div className="grid md:grid-cols-2 grid-cols-1 items-center mt-6 gap-[30px] relative">
            <div className="md:me-6">
              <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
                Therapy Connect
              </h6>
              <h4 className="font-bold lg:leading-normal leading-normal text-[42px] lg:text-[54px] mb-5">
                Gestión profesional para trainers y kinesiólogos
              </h4>
              <p className="text-slate-400 text-lg max-w-xl">
                Muestra a tus clientes una experiencia moderna: rutinas,
                ejercicios, chat y seguimiento de progreso en una sola
                plataforma.
              </p>

              <div className="mt-6">
                {/*                 <Link to="#">
                  <img src={app} className="h-12 inline-block m-1" alt="" />
                </Link> */}
                <Link to="https://play.google.com/store/apps/details?id=com.garymeliman.KnowYourBody">
                  <img src={play} className="h-12 inline-block m-1" alt="" />
                </Link>
              </div>
            </div>

            <div className="relative">
              <img
                src={phone}
                className="mx-auto w-80 rotate-12 relative z-2"
                alt="Therapy Connect inicio profesional"
              />
              <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tl to-red-500/20 via-red-500/70 from-red-500 bottom-1/2 translate-y-1/2 md:start-0 start-1/2 ltr:md:translate-x-0 ltr:-translate-x-1/2 rtl:md:translate-x-0 rtl:translate-x-1/2 z-1 shadow-md shadow-red-500/10 rounded-full"></div>

              <div className="overflow-hidden after:content-[''] after:absolute after:size-16 after:bg-red-500/20 after:top-0 after:end-6 after:z-1 after:rounded-lg after:animate-[spin_10s_linear_infinite]"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16" id="features">
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
              Funcionalidades
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              Todo lo necesario para tu operación diaria
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">
              Administra planes, comunica por chat en tiempo real y crea
              ejercicios desde un modelo 3D con base de ejercicios precargados.
            </p>
          </div>

          <FeaturesOne />
        </div>

        <div className="container relative md:mt-24 mt-16">
          <AboutOne />
        </div>

        <div className="container relative md:mt-24 mt-16">
          <AboutTwo />
        </div>
      </section>

      <section
        className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20"
        id="screenshot"
      >
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
              Capturas
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              Interfaz real de Therapy Connect
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">
              Estas pantallas muestran la experiencia real para profesionales y
              pacientes.
            </p>
          </div>
          <Screenshot />
        </div>
      </section>

      <span id="faq" />
      <section className="relative overflow-hidden md:py-24 py-16" id="faqs">
        <Faq />
      </section>

      <section
        className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20"
        id="download"
      >
        <Download />
      </section>

      {/*         <section className="relative md:py-24 py-16" id="reviews">
            <div className="container relative">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Testimonios</h6>
                    <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Profesionales que ya validaron el flujo</h4>

                    <p className="text-slate-400 max-w-xl mx-auto">Personal trainers y kinesiólogos compartieron su experiencia usando Therapy Connect.</p>
                </div>
                <Client/>
            </div>
        </section> */}

      <section
        className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20"
        id="contact"
      >
        <Contact />
      </section>

      <Footer />
    </>
  );
}
